module.exports = __webpack_public_path__ + "img/company_avatar.34bc8596.jpg";